// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4167":"6cef60db","4945":"c1796289","8763":"f684ce44","9525":"7f5c8b6d"}[chunkId] + ".chunk.css";
};